import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {META_SCREENS} from 'js/constants';
import {AppStore} from 'js/stores'; // singleton stores
import {BasicButton} from 'js/components/button';
import styles from 'css/screens/phaseresult.css';
import Chart from './chart';

@observer
/**
 * Phaseresult screen
 */
export default class Phaseresult extends Component {
  /**
   * constructor
   */
  constructor() {
    super();
  }

  /**
   * did mount
   */
  componentDidMount() {
    AppStore.pageView(META_SCREENS.phaseresult);
  }

  /**
   * will unmount
   */
  componentWillUnmount() {
    AppStore.pageLoading();
  }

  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    return (
      <section>
        <div className={`${styles.block} ${styles.title}`}>
          <h1>市場創造PR力診断</h1>
        </div>
        <div className={`${styles.block} ${styles.note}`}>
          <h2>市場創造フェーズ</h2>
          <p>
            <span>市場創造のPR活動には4つのフェーズがあります。</span><br />
            1. 立ち上げフェーズ&nbsp;&nbsp;
            2. 認知フェーズ&nbsp;&nbsp;
            3. コト訴求フェーズ&nbsp;&nbsp;
            4. 習慣化フェーズ<br />
            それぞれのフェーズによって何に注力するべきかが変わります。<br />
          </p>
        </div>
        <Chart />
        <div className={`${styles.block} ${styles.note}`}>
          <h2 className={styles.mapH2}>市場創造記号 7つの要素とは</h2>
          <p>
            市場創造記号とは、新習慣や新カテゴリを創出するための需要を喚起するキーワードのことです。
            例えば、「ファストファッション」という市場創造記号によって新たな市場が創造されました。
            市場創造記号は単に造語を作ればよいのではなく、メディアに取り上げられて世に広がるキーワードでなければなりません。
            市場創造記号は以下の7つの要素が含まれれば含まれるほど世の中への浸透度が高まります。
          </p>
        </div>
        <div className={styles.map} />
        {'web' == AppStore.selectAppType && (
          <div className={`${styles.block} ${styles.button}`}>
            <BasicButton href="https://www.bil.jp/inquiries/contact/">
              PR事例について問合せする
            </BasicButton>
          </div>
        )}
        <div className={`${styles.block} ${styles.link}`}>
          <a onClick={() => {
            location.href = 'https://www.bil.jp/';
          }}>
            コーポレートサイトトップへ
          </a>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/phaseresult/index.js